// sections
export const SETUP_LAYOUT_EDIT_SET_ALL_SECTIONS = 'SETUP_LAYOUT_EDIT_SET_ALL_SECTIONS';
export const SETUP_LAYOUT_EDIT_SET_ALL_FIELDS = 'SETUP_LAYOUT_EDIT_SET_ALL_FIELDS';
export const SETUP_LAYOUT_EDIT_ADD_FIELD_TO_SECTION = 'SETUP_LAYOUT_EDIT_ADD_FIELD_TO_SECTION';
export const SETUP_LAYOUT_EDIT_DELETE_FROM_SECTION = 'SETUP_LAYOUT_EDIT_DELETE_FROM_SECTION';
export const SETUP_LAYOUT_EDIT_MOVE_BETWEEN_SECTION = 'SETUP_LAYOUT_EDIT_MOVE_BETWEEN_SECTION';
export const SETUP_LAYOUT_EDIT_ADD_SECTION = 'SETUP_LAYOUT_EDIT_ADD_SECTION';
export const SETUP_LAYOUT_EDIT_DELETE_SECTION = 'SETUP_LAYOUT_EDIT_DELETE_SECTION';
export const SETUP_LAYOUT_EDIT_UPDATE_SECTION = 'SETUP_LAYOUT_EDIT_UPDATE_SECTION';
export const SETUP_LAYOUT_EDIT_MOVE_SECTION = 'SETUP_LAYOUT_EDIT_MOVE_SECTION';

export const SETUP_LAYOUT_EDIT_TOGGLE_SECTION_ADD_EDIT_DIALOG = 'SETUP_LAYOUT_EDIT_TOGGLE_SECTION_ADD_EDIT_DIALOG';
export const SETUP_LAYOUT_EDIT_SET_SECTION_ATTRIBUTE = 'SETUP_LAYOUT_EDIT_SET_SECTION_ATTRIBUTE';
export const SETUP_LAYOUT_EDIT_SET_CAN_DROP = 'SETUP_LAYOUT_EDIT_SET_CAN_DROP';

export const SETUP_LAYOUT_EDIT_FIELD = 'SETUP_LAYOUT_EDIT_FIELD';
export const SETUP_LAYOUT_CHANGE_FIELD_ATTR = 'SETUP_LAYOUT_CHANGE_FIELD_ATTR';

// modules action type
export const SETUP_LAYOUT_EDIT_SET_MODULES = 'SETUP_LAYOUT_EDIT_SET_MODULES';
export const SETUP_LAYOUT_EDIT_ADD_MODULES = 'SETUP_LAYOUT_EDIT_ADD_MODULES';
export const SETUP_LAYOUT_EDIT_SORT_MODULES = 'SETUP_LAYOUT_EDIT_SORT_MODULES';
export const SETUP_LAYOUT_EDIT_DELETE_MODULES = 'SETUP_LAYOUT_EDIT_DELETE_MODULES';

// tools action type
export const SETUP_LAYOUT_EDIT_SET_TOOLS = 'SETUP_LAYOUT_EDIT_SET_TOOLS';
export const SETUP_LAYOUT_EDIT_ADD_TOOLS = 'SETUP_LAYOUT_EDIT_ADD_TOOLS';
export const SETUP_LAYOUT_EDIT_SORT_TOOLS = 'SETUP_LAYOUT_EDIT_SORT_TOOLS';
export const SETUP_LAYOUT_EDIT_DELETE_TOOLS = 'SETUP_LAYOUT_EDIT_DELETE_TOOLS';

// right sider tab action types
export const SETUP_LAYOUT_EDIT_SET_CURRENT_TAB = 'SETUP_LAYOUT_EDIT_SET_CURRENT_TAB';
export const SETUP_LAYOUT_EDIT_SET_CURRENT_LAYOUT = 'SETUP_LAYOUT_EDIT_SET_CURRENT_LAYOUT';



// WEBPACK FOOTER //
// ./src/views/Setup/PageLayout/flow/edit/actionType.js